import { useGarden } from '../../garden/GardenContext';
import { ELEMENT_TYPES, ELEMENT_CATEGORIES } from '../../garden/constants';
import type { ElementMeta } from '../../garden/constants';
import { ICONS_BY_TYPE } from '../../icons/IconLibrary';
import type { IconProps } from '../../icons/IconLibrary';
import './Palette.css';

function iconPropsFor(meta: ElementMeta): IconProps {
  return meta.resizable
    ? { width: 32, height: (32 * (meta.defaultHeight as number)) / (meta.defaultWidth as number) }
    : { size: 32 };
}

function Palette() {
  const { armedType, armType } = useGarden();

  return (
    <aside className="palette">
      <p className="palette__hint">
        {armedType ? 'Click the canvas to place it.' : 'Select an item, then click the canvas.'}
      </p>
      {Object.entries(ELEMENT_CATEGORIES).map(([category, categoryLabel]) => (
        <div key={category} className="palette__section">
          <h2 className="palette__title">{categoryLabel}</h2>
          <ul className="palette__list">
            {ELEMENT_TYPES.filter((meta) => meta.category === category).map((meta) => {
              const Icon = ICONS_BY_TYPE[meta.type];
              const isArmed = armedType === meta.type;
              return (
                <li key={meta.type}>
                  <button
                    type="button"
                    className={`palette__item${isArmed ? ' palette__item--armed' : ''}`}
                    onClick={() => armType(meta.type)}
                    aria-pressed={isArmed}
                  >
                    <Icon {...iconPropsFor(meta)} />
                    <span className="palette__label">{meta.label}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </aside>
  );
}

export default Palette;
